import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/auth/me").then((r) => alive && setUser(r.data)).catch(() => alive && setUser(false));
    return () => { alive = false; };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen grid place-items-center bg-[#0A0A0C] font-mono-rc text-xs tracking-[0.3em] text-[#C4832B]">LOADING</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
